<template>
  <div>
    <v-row v-if="grafData1.length > 0">
      <v-col cols="12">
        <line-chart
          :chart-data="grafValues(1)"
          :options="grafOptions(1)"
        ></line-chart>
      </v-col>
    </v-row>
    <v-row v-if="grafData2.length > 0">
      <v-col cols="12">
        <line-chart
          :chart-data="grafValues(2)"
          :options="grafOptions(2)"
        ></line-chart>
      </v-col>
    </v-row>
  </div>
</template>

<script>
//import * as moment from "moment"
import * as Colors from "@/plugins/colors.js"
import LineChart from "./LineChart.js"

export default {
  data: function () {
    return {
      loading: false,
      grafData1: [],
      grafData2: [],
    }
  },
  components: { LineChart },
  props: {
    bod: {
      type: Object,
      required: true,
    },
    minYear: {
      type: Number,
      required: true,
    },
    maxYear: {
      type: Number,
      required: true,
    },
  },
  computed: {},
  watch: {
    bod: {
      immediate: true,
      handler: function () {
        this.show()
      },
    },
  },
  methods: {
    grafValues: function (aIndex) {
      let ret = ""
      if (aIndex === 1) {
        let colors = Colors.defaultColors()
        console.log("colors", colors)
        let colorIndex = 0
        let datasets = []
        this.grafData1.forEach((item) => {
          let dataset = {}
          dataset = {
            label: item.Obdobie,
            type: "line",
            backgroundColor: colors[colorIndex],
            borderColor: colors[colorIndex],
            pointRadius: "0",
            borderWidth: "1",
            lineTension: 0,
            pointStyle: "line",
            fill: false,
            data: item.Hodnoty,
          }
          colorIndex++
          datasets.push(dataset)
        })
        ret = {
          labels: [1, 2, 3, 4, 5, 6, 7, 8],
          datasets: datasets,
        }
      }
      if (aIndex === 2) {
        ret = {
          labels: [1, 2, 3, 4, 5, 6, 7, 8],
          datasets: [
            {
              label: "Suma",
              type: "line",
              backgroundColor: "#0000ff",
              borderColor: "#0000ff",
              pointRadius: "0",
              borderWidth: "1",
              lineTension: 0,
              pointStyle: "line",
              fill: false,
              data: this.grafData2,
            },
          ],
        }
      }
      return ret
    },
    grafOptions: function (aIndex) {
      let ret = ""
      ret = {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          //display: false
        },
        title: {
          display: true,
          text:
            aIndex === 1
              ? "Mikromorfologické zmeny"
              : "Suma Mikromorfologických zmien povrchu horniny",
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "[mm]",
              },
            },
          ],
        },
      }
      return ret
    },
    urlFetch: function () {
      let url = "/chart/mikroniv"
      url += "?bodID=" + this.bod.ID
      url += "&rokOd=" + this.minYear
      url += "&rokDo=" + this.maxYear
      return url
    },
    show: async function () {
      this.grafData1 = []
      this.grafData2 = []
      try {
        this.loading = true
        let response = await this.$axios.get(this.urlFetch())
        if (response.status === 200) {
          this.grafData1 = response.data.data
          this.grafData2 = response.data.suma
          if (this.grafData1 === null) {
            this.grafData1 = []
          }
          if (this.grafData2 === null) {
            this.grafData2 = []
          }
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      } finally {
        this.loading = false
      }
    },
  },
  mounted: function () {},
}
</script>
